function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6017 16.2041H4.9624V18.2906H18.6017V16.2041Z",
  fill: "#F4F4F4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2937 15.1973H11.0937V14.0002H12.0857V15.198H12.8857V13.9885C13.613 13.9558 14.1584 13.8431 14.5184 13.6584C14.9012 13.4743 15.2238 13.185 15.4482 12.8244C15.6727 12.4638 15.7899 12.0468 15.7861 11.622C15.7861 10.8402 15.389 9.93836 14.3031 9.59582C14.5415 9.4787 14.7592 9.32345 14.9475 9.13618C15.2813 8.82709 15.4566 8.37472 15.4566 7.82709C15.4566 7.53618 15.3839 6.55582 14.4813 5.97982C14.005 5.68891 13.381 5.60673 12.8813 5.58491V4.43945H12.0813V5.58127H11.0915V4.43945H10.2915V5.58127H9.22021V14.0002H10.2937V15.1973ZM11.1388 7.08091H12.2064C12.9271 7.08091 13.5235 7.14854 13.5235 7.97836C13.5271 8.83654 12.89 8.90927 12.2406 8.90927H11.1388V7.08091ZM11.1388 10.4213H12.0253C13.0282 10.4213 13.7955 10.4984 13.7955 11.4664C13.7955 12.3755 13.1664 12.4431 12.2064 12.4431H11.1388V10.4213Z",
  fill: "#F4F4F4"
});

const SvgMBtc = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMBtc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mBTC.0a574129.svg";
export { ForwardRef as ReactComponent };